import React from "react";
import { ReactComponent as ReviewStar } from "assets/svgs/star-rating.svg";
import { ReactComponent as WhiteReviewStar } from "assets/svgs/white-star-rating.svg";

const ReviewStars = ({ rating, className }) => (
    <div className={`flex gap-2 ${className}`}>
        {[...Array(5)].map((review, index) => {
            if (index < Math.round(rating)) return <ReviewStar key={Math.random()} />;
            return <WhiteReviewStar key={Math.random()} />;
        })}
    </div>
);

export default ReviewStars;
